// project import
import dashboard from './dashboard';
import projects from './clones';
import modules from './modules';
import pages, { getAuthMenuItems } from './page';
import { isUiHidden } from 'config/hiddenUi';

// ==============================|| MENU ITEMS ||============================== //

function mainMenuGroups() {
  const items = [dashboard, projects];
  if (!isUiHidden('modules')) {
    items.push(modules);
  }
  return items;
}

// Функция для получения меню в зависимости от статуса аутентификации
export const getMenuItems = (isAuthenticated) => {
  const authMenu = getAuthMenuItems(isAuthenticated);
  return {
    items: [...mainMenuGroups(), authMenu]
  };
};

// Дефолтное меню для неаутентифицированных пользователей
const menuItems = {
  items: [...mainMenuGroups(), pages]
};

export default menuItems;
